import { GetNotificationsUseCase } from '@/application/notification/getNotificationsUseCase';
import { notificationApiRepository } from '@/infra/repositories/notificationApi.repository';

let _getNotificationsUseCase: GetNotificationsUseCase | null = null;

/**
 * Función que inyecta una instancia de GetUserPendingNotificationsUseCase
 * Proporciona acceso al caso de uso para obtener notificaciones pendientes
 */

export const getNotificationsUseCase = (): GetNotificationsUseCase => {
  if (!_getNotificationsUseCase) {
    _getNotificationsUseCase = new GetNotificationsUseCase(
      notificationApiRepository,
    );
  }

  return _getNotificationsUseCase;
};

/**
 * Función para resetear las instancias
 */
export const resetNotificationContainer = (): void => {
  _getNotificationsUseCase = null;
};
